import { Component, Input, Output, EventEmitter } from '@angular/core';
import { ProjectNode } from 'src/app/shared/models/projectNode';

@Component({
  selector: 'app-tree-card',
  templateUrl: './tree-card.component.html',
  styleUrls: ['./tree-card.component.scss']
})
export class TreeCardComponent {
  @Input() node!: ProjectNode;
  @Input() isSelected: boolean = false;
  @Output() onNodeSelected = new EventEmitter<ProjectNode>();
  @Output() onModelSelection = new EventEmitter<ProjectNode>();
  @Output() onModelSelected = new EventEmitter<any>();
  @Output() onModelDeselected = new EventEmitter<any>();
  @Output() onToggleChange = new EventEmitter<{node: ProjectNode, checked: boolean}>();

  onCardClick() {
    if (this.node.nodes && this.node.nodes.length > 0) {
      this.onNodeSelected.emit(this.node);
    } else {
      this.onModelSelection.emit(this.node);
    }
  }

  handleToggleChange(event: Event) {
    const checked = (event.target as HTMLInputElement).checked;
    this.onToggleChange.emit({ node: this.node, checked });
  }
}
